<template>
  <div>
    <div class="mb-3 py-3 pb-2">
      <div class="row">
        <div class="col-md-12">
          <b-input-group>
            <b-input-group-text slot="prepend" class="bg-shade-1">
              <i class="fa fa-search" />
            </b-input-group-text>
            <b-input
              v-model="search"
              placeholder="Search by name, keyword or mathematical classification number"
              autocomplete="off"
              data-lpignore="true"
              @input="filteredList('search', null)"
            />
          </b-input-group>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 col-md-border">
        <b-card v-if="mergedData" id="upcoming-tab" no-body class="mb-2">
          <b-card-header class="custom-card-header-event">
            <div
              v-if="event != 'GeneralEvent'"
              id="upcoming-event-id"
              class="lyon-display-medium-21"
            >
              Current and Upcoming
            </div>
            <div v-else id="upcoming-event-id" class="lyon-display-medium-21">Public Events</div>
          </b-card-header>
          <div v-if="upcomingPaginationLoading || loading">
            <generic-loader />
          </div>
          <div v-else-if="mergedData.length === 0" class="d-flex justify-content-center pt-5 pb-5">
            <span class="text-muted regular-14">No result</span>
          </div>
          <div v-else>
            <div class="main-content">
              <div v-for="(item, index) in mergedData" :key="index">
                <div
                  v-if="item.id"
                  class="cursor-pointer" @click="eventClick(item, `${tabId}`+'scientific-activity-home-grid-dtl-id')"
                >
                  <left-grid-event-list
                    :event-item="item"
                    :active-item-id="activeItemId"
                  />
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center flex-shrink-0 mt-3">
              <b-pagination
                v-model="upcomingDataPage"
                pills
                :total-rows="upcomingPagination.total_rows"
                @input="filteredPagination('pagination', 'upcomingPage')"
              />
            </div>
          </div>
        </b-card>

        <!-- <b-card id="upcoming-tab" no-body class="mb-2">
          <b-card-header class="custom-card-header-event">
            <div
              v-if="event != 'GeneralEvent'"
              id="upcoming-event-id"
              class="lyon-display-medium-21"
            >
              Upcoming
            </div>
            <div v-else id="upcoming-event-id" class="lyon-display-medium-21">Public Events</div>
          </b-card-header>
          <div v-if="upcomingPaginationLoading || loading" class="loader-container">
            <generic-loader />
          </div>
          <div v-else>
            <div v-if="upcomingData.length === 0" class="d-flex justify-content-center pt-5 pb-5">
              <span class="text-muted regular-14">No result</span>
            </div>
            <div v-else>
              <div class="main-content">
                <div v-for="(item, index) in upcomingData" :key="index">
                  <div
                    v-if="item.id"
                    class="cursor-pointer" @click="eventClick(item, `${tabId}`+'scientific-activity-home-grid-dtl-id')"
                  >
                    <left-grid-event-list
                      :event-item="item"
                      :active-item-id="activeItemId"
                    />
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center flex-shrink-0 mt-3">
                <b-pagination
                  v-model="upcomingDataPage"
                  pills
                  :total-rows="upcomingPagination.total_rows"
                  @input="filteredPagination('pagination', 'upcomingPage')"
                />
              </div>
            </div>
          </div>
        </b-card> -->

        <b-card v-if="pastData && showPast" id="past-tab" no-body>
          <b-card-header class="custom-card-header-event">
            <div id="past-event-id" class="lyon-display-medium-21">Past</div>
          </b-card-header>
          <div v-if="pastPaginationLoading || loading" class="loader-container">
            <generic-loader />
          </div>
          <div v-else>
            <div v-if="pastData.length === 0" class="d-flex justify-content-center pt-5 pb-5">
              <span class="text-muted regular-14">No result</span>
            </div>
            <div v-else>
              <div class="main-content">
                <div v-for="(item, index) in pastData" :key="index">
                  <div
                    v-if="item.id"
                    class="cursor-pointer" @click="eventClick(item, `${tabId}`+'scientific-activity-home-grid-dtl-id')"
                  >
                    <left-grid-event-list
                      :event-item="item"
                      :active-item-id="activeItemId"
                    />
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center flex-shrink-0 mt-3">
                <b-pagination
                  v-model="pastDataPage"
                  pills
                  :total-rows="pastPagination.total_rows"
                  @input="filteredPagination('pagination', 'pastPage')"
                />
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <div :id="`${tabId}`+'scientific-activity-home-grid-dtl-id'" class="col-md-6 col-md-border right-side-section sticky-content">
        <div v-if="showDetails">
          <custom-loader v-if="loadingDetails" />
          <b-card v-else>
            <span class="px-2 mb-2 badge badge-secondary">
              <span class="regular-16 typo-color-white">
                {{ getUniqueEventName(eventType) }}
              </span>
            </span>
            <right-grid-event-detail
              :selected-event="selectedEvent"
              :active-item-id="activeItemId"
              :button-name="`VIEW DETAILS`"
              :page-name="eventPathTypeDynamic(eventType)"
            />
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLoader from "@/components/CommonPages/CustomLoader.vue"
import GenericLoader from "@/components/Loaders/GenericLoader.vue"
import LeftGridEventList from "@/components/CommonPages/LeftGridEventList.vue"
import RightGridEventDetail from "@/components/CommonPages/RightGridEventDetail.vue"
import mixin from "@/utils/mixin.js"
import { scrollToElementId } from "@/utils/CommonUtils.js"

export default {
	name: "ScientificActivityEvents",
	components: { GenericLoader, LeftGridEventList, RightGridEventDetail, CustomLoader },
	mixins: [mixin],
	props: [
		"currentData",
		"upcomingData",
		"pastData",
		"pastPagination",
		"upcomingPagination",
		"loading",
		"tabId",
		"event",
		"upcomingPaginationLoading",
		"pastPaginationLoading",
		"mergedData",
		"showPast",
	],
	data() {
		return {
			selectedEvent: {},
			showDetails: false,
			activeItemId: "",
			eventType: "",
			eventUrl: "",
			loadingDetails: false,
			search: "",
			upcomingDataPage: 1,
			pastDataPage: 1,
		}
	},
	methods: {
		filteredList(val, pageType) {
			scrollToElementId("scientific_activity_events")
			this.showDetails = false
			if (val === "search") {
				this.upcomingDataPage = 1
				this.pastDataPage = 1
			}
			setTimeout(() => {
				const searchValue = this.search.toLowerCase()
				const page = pageType === "upcomingPage" ? this.upcomingDataPage : this.pastDataPage
				this.$root.$emit("updateSearchList", this.event, searchValue, page, this.tabId)
			}, 800)
		},
		filteredPagination(val, pageType) {
			scrollToElementId(pageType === "upcomingPage" ? "upcoming-tab" : "past-tab")
			this.showDetails = false
			if (val === "search") {
				this.upcomingDataPage = 1
				this.pastDataPage = 1
			}
			setTimeout(() => {
				const searchValue = this.search.toLowerCase()
				const page = pageType === "upcomingPage" ? this.upcomingDataPage : this.pastDataPage
				this.$root.$emit("updatePaginationList", this.event, searchValue, page, pageType, this.tabId)
			}, 800)
		},
		eventClick(data, selectedId) {
			this.showDetails = true
			this.loadingDetails = true
			if (window.innerWidth < 768) {
				scrollToElementId(selectedId)
			}
			this.activeItemId = data.id
			this.eventType = data.event_type
			this.eventUrl = this.eventPathURLDynamic(data.event_type)
			const apiCall = this.eventApiDynamic(data.event_type)
			this.$http
				.get(`${process.env.VUE_APP_API_URL}/${apiCall}/${data.id}/show_event`)
				.then((res) => {
					if (res?.data) {
						this.selectedEvent = Object.assign({}, res.data)
					}
				})
				.finally(() => {
					this.loadingDetails = false
				})
		},
	},
}
</script>

<style lang="scss" scoped>
.custom-card-header-event {
  background-color: #eeeeee !important;
  cursor: pointer !important;
  padding: 5px 20px 5px !important;
}

.right-side-section {
  overflow-y: auto;
  // height: 500px;
  border: 0px !important;
  @media (max-width: 47.9rem) {
    height:auto !important;
    padding-top: 1rem !important;
  }
}

.loader-container{
   height: 568px
}

</style>
